/* IntelApps — Team Page */
import React, { useEffect } from "react";
import Header from "../parts/Header.js";
import Footer from "../parts/Footer.js";
import DiscussCTA from "../parts/Discuss.js";
import teamHeroImg from "../assets/images/hero/team.png";

const TEAM = [
  // {
  //   name: "Brent Morgan",
  //   role: "CEO & Founder",
  //   img: "/assets/team/ceo.jpg",
  //   bio: "15+ years building products at Google, Stripe, and three startups.",
  // },
  {
    name: "David Kuczynski",
    role: "CTO",
    img: "/assets/team/david.png",
    bio: "15+ years building products at Google, Stripe, and three startups.",
  },
  {
    name: "Jason Reed",
    role: "Head of AI/ML",
    img: "/assets/team/backend.jpg",
    bio: "Former ML lead at OpenAI. PhD in NLP from Stanford.",
  },
  {
    name: "Daniel Wang",
    role: "Web Lead",
    img: "/assets/team/backend2.jpg",
    bio: "Core contributor to Next.js. Full-stack specialist.",
  },
  {
    name: "Johnny Zhang",
    role: "Mobile Lead",
    img: "/assets/team/mobile1.jpg",
    bio: "Ex-Apple iOS engineer. 50+ apps shipped to App Store.",
  },
  {
    name: "James Okonkwo",
    role: "Blockchain Lead",
    img: "/assets/team/caller.png",
    bio: "Former smart contract auditor at ConsenSys. Solidity expert.",
  },
  {
    name: "Robert Anderson",
    role: "Product Manager",
    img: "/assets/team/pm.jpg",
    bio: "Ex-Google PM. Led 20+ product launches.",
  },
  {
    name: "Elena Rodriguez",
    role: "Design Director",
    img: "/assets/team/uiux1.png",
    bio: "Previously design lead at Figma. Specializes in complex systems.",
  },
  {
    name: "Anna Martinez",
    role: "Head of People",
    img: "/assets/team/headp.png",
    bio: "Building high-performance teams for 12 years.",
  },
];

export default function TeamPage() {
  useEffect(() => {
    document.title = "IntelApps — Team";
  }, []);

  return (
    <>
      <Header />
      <main>
        <section className="page-hero">
          <div className="container page-hero-grid">
            <div>
              <span className="eyebrow">Team</span>
              <h1>50+ engineers, designers, and product experts.</h1>
              <p className="page-hero-sub">
                Senior people who ship. No middle-men, no handoffs — everyone
                you meet in kickoff is on your project.
              </p>
            </div>
            <div className="page-hero-media">
              <img src={teamHeroImg} alt="Our team collaborating" />
            </div>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="team-grid">
              {TEAM.map((m) => (
                <div key={m.name} className="team-member">
                  <img src={m.img} alt={m.name} />
                  <div className="team-member-body">
                    <p className="team-member-name">{m.name}</p>
                    <p className="team-member-role">{m.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <DiscussCTA />
      </main>
      <Footer />
    </>
  );
}
